// extracted by mini-css-extract-plugin
export default {"getOutline":"Welcome_getOutline__7ppva","Welcome":"Welcome_Welcome__nEvF1"};